import LegalShell from '@/components/LegalShell';

export default function RefundPage() {
  return (
    <LegalShell eyebrow="Legal" title="Refund &amp; Cancellation Policy." lastUpdated="April 2026">
      <div data-testid="refund-page" className="space-y-6 text-foreground/85 leading-relaxed">
        <p>
          We want every purchase on <strong>Radiance Hub</strong> to feel fair. Please read this policy
          carefully before buying credits.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">1. Digital product</h2>
        <p>
          Credits purchased on Radiance Hub are a digital product delivered to your account instantly
          upon successful payment. Because credits are consumed on demand (AI Q&amp;A, Styling, Regimen) and
          have no physical form, <strong>purchases are non-refundable</strong>.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">2. Cancellations</h2>
        <p>
          There is no subscription. You pay only when you purchase a credit pack, so there is nothing to
          cancel. You can stop using the Service at any time — your unused credits remain on your
          account.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">3. Exceptions</h2>
        <p>We will review refund requests only in the following specific scenarios:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>You were charged but credits were not delivered to your account due to a technical failure on our side;</li>
          <li>You were charged twice for the same order (duplicate transaction);</li>
          <li>Unauthorized purchase reported within 72 hours of the transaction, subject to verification.</li>
        </ul>
        <p>
          In these cases, email{' '}
          <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>
          {' '}with your order ID, payment ID and a brief description. Approved refunds are processed via
          Razorpay to the original payment method within 7–10 business days.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">4. AI output disclaimer</h2>
        <p>
          Credit use is non-refundable even if you are not satisfied with a particular AI response
          (e.g., the AI could not read your photo). AI features are provided on a “best effort” basis.
          In cases where our system clearly failed to deliver an analysis (e.g., server error), we
          automatically refund the credits to your balance.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">5. Contact</h2>
        <p>
          Radiance Hub, Mumbai, Maharashtra, India.
          <br />
          Email: <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>
        </p>
      </div>
    </LegalShell>
  );
}
